import { arrayOfAll } from '../_lib';
const arrayOfAllWebhookEvents = arrayOfAll();
export const WEBHOOK_EVENTS = arrayOfAllWebhookEvents([
    'chat_created',
    'chat_message_created',
    'record_created',
    'record_deleted',
    'record_updated'
]);
